import { Controller } from "@hotwired/stimulus";
import {
  fetchDiePriceTable,
  fetchForgingPriceTable,
  fetchMachinePartsPriceTable,
  fetchNimdenPriceTable,
  fetchClientPeelingPrice
} from "./utils/fetch_price_table";

export default class extends Controller {
  static targets = [
    "orderQuantity",
    "orderSet",
    "orderTotalQuantity",
    "deliveryAt",
    "deliveryTime",
    "duration"
  ];
  connect() {
    console.log("OrderFormController connected");
    this.setTotalQuantity();
  }

  resetProcedure(event) {
    const select = event.currentTarget;
    const originalForm = select.closest("form");
    const workId = select.closest("tr").dataset.workId;

    const form = originalForm.cloneNode(true);
    form.style.display = "none";

    form
      .querySelectorAll('[name="commit"], [name="work_id"]')
      .forEach((el) => el.remove());

    const addHidden = (name, value) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };

    addHidden("commit", "加工手順リセット");
    addHidden("work_id", workId);
    addHidden("procedure_id", select.value);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  calculatePriceAndContainer(event) {
    const tr = event.target.closest("tr");
    this.calculateAndSetPrice(tr);
    // this.calculateAndSetCost(tr);
    const container = event.target.closest(".children-container");
    this.calculateAndSetProcedureApiece(container);
    this.calculateAndSetProcedureCost(container);
  }

  calculateAndSetPrice(tr) {
    const apiece = tr.querySelector("[id$=_apiece]").value || 0;
    const quantity = this.element.querySelector("#order_quantity").value || 0;
    const price = parseInt(apiece) * quantity;
    tr.querySelector("[id$=_price]").value = price;
  }

  async fetchShinkoPriceTable(t, dm) {
    const response = await fetch(
      `/die_price_tables/17/fetch_price_from_id?t=${t}&dm=${dm}`
    );
    const cost = await response.json();
    return cost || 0;
  }

  calculateAndSetProcedureApiece(container) {
    const procedureApiece = Array.from(
      container.querySelectorAll("[name*=apiece]")
    ).reduce((prev, current) => prev + (parseFloat(current.value) || 0), 0);
    const field = container.closest(".child-field");
    field.querySelector("[id$=_procedure_apiece]").value = procedureApiece;
    this.calculateAndSetProcedureTotalPrice(field);
    this.calculateAndSetOrderTotalApiece();
  }

  calculateAndSetProcedureTotalPrice(field) {
    const quantity = parseInt(
      this.element.querySelector("#order_quantity").value
    );
    const apiece = parseInt(
      field.querySelector("[name*=procedure_apiece]").value
    );
    field.querySelector("[name*=procedure_total_price]").value =
      quantity * apiece || 0;
    this.calculateAndSetOrderTotalPrice();
  }

  calculateAndSetOrderTotalApiece() {
    const orderTotalApiece = Array.from(
      this.element.querySelectorAll("[name*=procedure_apiece]")
    ).reduce((prev, current) => prev + (parseFloat(current.value) || 0), 0);
    this.element.querySelector("#order_total_apiece").value = orderTotalApiece;
  }

  calculateAndSetOrderTotalPrice() {
    const orderTotalPrice = Array.from(
      this.element.querySelectorAll("[name*=procedure_total_price]")
    ).reduce((prev, current) => prev + (parseFloat(current.value) || 0), 0);
    this.element.querySelector("#order_total_price").value = orderTotalPrice;
  }

  calculateAndSetProcedureCost(container) {
    const procedureCost = Array.from(
      container.querySelectorAll("[name*=cost]")
    ).reduce((prev, current) => prev + (parseFloat(current.value) || 0), 0);
    const field = container.closest(".child-field");
    field.querySelector("[id$=_procedure_cost]").value = procedureCost;
    this.calculateAndSetProcedureTotalCost(field);
  }

  calculateAndSetProcedureTotalCost(field) {
    const quantity = parseInt(
      this.element.querySelector("#order_quantity").value
    );
    const cost = parseInt(field.querySelector("[name*=procedure_cost]").value);
    field.querySelector("[name*=procedure_total_cost]").value =
      quantity * cost || 0;
    this.calculateAndSetOrderTotalCost();
  }

  calculateAndSetOrderTotalCost() {
    const orderTotalCost = Array.from(
      this.element.querySelectorAll("[name*=procedure_total_cost]")
    ).reduce((prev, current) => prev + (parseFloat(current.value) || 0), 0);
    this.element.querySelector("#order_total_cost").value = orderTotalCost;
  }

  async autoCalculateAllContainers() {
    // No jQuery and ajax use Stimulus, vanilla JS and fetch instead
    const productType = this.element.querySelector("[id$=_product_type]").value;
    const branchId = this.element.querySelector("[id$=_branch_id]").value;
    const length = this.element.querySelector("[id$=_length]").value;
    const width = this.element.querySelector("[id$=_width]").value;
    const t = this.element.querySelector("[id$=_weight]").value;
    const dm = this.element.querySelector("[id$=_area]").value;

    const workFields = this.element.querySelectorAll("[name$=work-field]");
    for (const workField of workFields) {
      const procedureId = workField.querySelector(
        "select[id$=procedure_id]"
      ).value;
      let price = 0;
      let cost = 0;

      const supplierNames = workField.querySelectorAll("[name*=supplier_name]");
      for (const supplierName of supplierNames) {
        const supplier_name = supplierName.value;
        if (supplier_name !== "新硬クローム工業株式会社") continue;
        const costElement = supplierName
          .closest("tr")
          .querySelector("[id$=_cost]");

        if (
          costElement.classList.contains("main_process_cost") &&
          !costElement.value
        ) {
          cost = await this.fetchShinkoPriceTable(t, dm);
          costElement.value = cost;
        }
      }

      const processNames = workField.querySelectorAll("[name*=process_name]");
      for (const processName of processNames) {
        const process_name = processName.value;
        if (process_name !== "はくり") continue;

        price = await fetchClientPeelingPrice(branchId);
        const tr = processName.closest("tr");
        tr.querySelector("[id$=_apiece]").value = parseInt(price);
        tr.querySelector("[id$=_price]").value =
          parseInt(price) *
          parseInt(this.element.querySelector("#order_quantity").value);
      }

      if (procedureId === "6") {
        const maxPlatingThickness = workField.querySelector(
          "[id$=max_plating_thickness]"
        ).value;
        price = await fetchNimdenPriceTable(dm, maxPlatingThickness);
      } else if (productType === "プレス金型") {
        price = await fetchDiePriceTable(t, dm, branchId);
      } else if (productType === "鍛造型") {
        price = await fetchForgingPriceTable(length, width, branchId);
      } else if (productType === "機械部品") {
        const maxPlatingThickness = workField.querySelector(
          "[id$=max_plating_thickness]"
        ).value;
        price = await fetchMachinePartsPriceTable(
          dm,
          branchId,
          maxPlatingThickness
        );
      }

      const mainProcessApiece = workField.querySelector(".main_process_apiece");

      if (mainProcessApiece && !mainProcessApiece.value) {
        mainProcessApiece.value = price;
      }
    }

    setTimeout(() => {
      this.element
        .querySelectorAll("[name=work-field] .children-container")
        .forEach((container) => {
          this.calculateAndSetProcedureApiece(container);
          this.calculateAndSetProcedureCost(container);
        });
      this.element.querySelectorAll(".work-step-row").forEach((tr) => {
        this.calculateAndSetPrice(tr);
      });
    }, 100);
  }

  /////////////////////////
  // Geometry Calculator //
  /////////////////////////

  ceiledValue(area, scale) {
    const scaledValue = area * scale * 0.0001 * 10;
    return Math.ceil(scaledValue) / 10;
  }

  cylinder(geometry_calculator_id) {
    const outerDiameter = parseInt(
      this.element.querySelector("[id$=_length]").value
    );
    const length = parseInt(this.element.querySelector("[id$=_width]").value);
    const pi = Math.PI;

    const radius = outerDiameter / 2;
    const radiusArea = radius ** 2 * pi;

    function calculateArea(geometryId) {
      const baseArea = outerDiameter * pi * length;

      switch (geometryId) {
        case 1:
          return baseArea;
        case 2:
          return baseArea + radiusArea;
        case 3:
          return baseArea + 2 * radiusArea;
        case 4:
          return 2 * baseArea + radiusArea;
        case 5:
          return 2 * baseArea + 2 * radiusArea;
        default:
          return 0;
      }
    }
    const scale =
      parseFloat(this.element.querySelector("[id$=_scale]").value) || 0;
    const area = calculateArea(geometry_calculator_id) || 0;

    this.element.querySelector("[id$=_area]").value = this.ceiledValue(
      area,
      scale
    );
  }

  block(geometry_calculator_id) {
    const middle = parseInt(this.element.querySelector("[id$=_length]").value);
    const large = parseInt(this.element.querySelector("[id$=_width]").value);
    const small = parseInt(this.element.querySelector("[id$=_height]").value);
    let area = 0;

    function calculateArea(geometryId) {
      switch (geometryId) {
        case 6:
          return (small + middle) * large;
        case 7:
          return (small * 2 + middle) * large;
        case 8:
          return (small + middle) * 2 * large;
        default:
          return 0;
      }
    }

    const scale = this.element.querySelector("[id$=_scale]").value;
    area = calculateArea(geometry_calculator_id);

    this.element.querySelector("[id$=_area]").value = this.ceiledValue(
      area,
      scale
    );
  }

  calculateArea() {
    const geometry_calculator_id = parseInt(
      this.element.querySelector("select[id$=_geometry_calculator_id]").value
    );
    if (geometry_calculator_id <= 5) {
      this.cylinder(geometry_calculator_id);
    } else {
      this.block(geometry_calculator_id);
    }
  }

  // 寸法Ａ	寸法Ｂ	寸法Ｃ	面積	計算式
  // 外径	長さ
  // 100	500		15.7ｄ㎡	外径×3.14×長さ＊（ｄ㎡換算÷10000）
  // 500	500		98.1ｄ㎡	（外径×3.14×長さ+外径の半径＊外径の半径＊3.14）＊（ｄ㎡換算÷10000）
  // 500	300		204.1ｄ㎡	（外径×3.14×長さ+外径の半径×外径の半径×3.14）×2×（ｄ㎡換算÷10000）
  // 500	500		176.6ｄ㎡	外径×3.14×長さ＊2+外径の半径＊外径の半径×3.14×（ｄ㎡換算÷10000）
  // 500	500		196.3ｄ㎡	（外径×3.14×長さ+外径の半径×外径の半径×3.14）×2×（ｄ㎡換算÷10000）
  // 寸法Ａ	寸法Ｂ	寸法Ｃ	面積	計算式
  // 中	大	小
  // 300	500	200	25.0ｄ㎡	（中×小）×大×（ｄ㎡換算÷10000）
  // 300	500	200	35.0ｄ㎡	（小×2+中）×大×（ｄ㎡換算÷10000）
  // 300	500	200	50.0ｄ㎡	（小+中）×2×大×（ｄ㎡換算÷10000）

  setTotalQuantity(event) {
    if (this.orderSetTarget.value == "式") return;
    this.orderTotalQuantityTarget.value = this.orderQuantityTarget.value;
  }

  async fetchDestinationCompanyDuration(event) {
    const tbody = event.target.closest("tbody");
    const id = event.target.value;
    if (!id) return;

    const response = await fetch(`/destination_companies/${id}`, {
      headers: {
        Accept: "application/json"
      }
    });
    const destination_company = await response.json();
    if (!destination_company) return;

    tbody.querySelector("[id$=_delivery_representative]").value =
      destination_company.default_representative;
    tbody.querySelector("[id$=_duration]").value = destination_company.duration;
    this.setDeliveryArrivalDateTime(event);
  }

  setDeliveryArrivalDateTime(event) {
    // No jQuery and ajax use Stimulus, vanilla JS and fetch instead
    const tbody = event.target.closest("tbody");
    const type = tbody.getAttribute("name");

    const deliveryAt = tbody.querySelector("[id$=_delivery_at]").value;
    const deliveryTime = tbody.querySelector("[id$=_delivery_time]").value;
    const duration = tbody.querySelector("[id$=_duration]").value;
    if (!duration) return;

    const fullDate = new Date(`${deliveryAt}T${deliveryTime}:00+09:00`);
    if (type === "InDelivery") {
      fullDate.setMinutes(fullDate.getMinutes() + parseInt(duration));
    } else {
      fullDate.setMinutes(fullDate.getMinutes() - parseInt(duration));
    }

    const jstDate = new Date(
      fullDate.getTime() +
        fullDate.getTimezoneOffset() * 60 * 1000 +
        9 * 60 * 60 * 1000
    );

    const year = jstDate.getFullYear();
    const month = ("0" + (jstDate.getMonth() + 1)).slice(-2);
    const date = ("0" + jstDate.getDate()).slice(-2);
    const arrivalDate = `${year}-${month}-${date}`;

    const arrivalTime = jstDate.toTimeString().split(" ")[0];
    const formattedArrivalTime = arrivalTime.split(":").slice(0, 2).join(":");

    tbody.querySelector("[id$=_delivery_arrival_at]").value = arrivalDate;
    tbody.querySelector("[id$=_delivery_arrival_time]").value =
      formattedArrivalTime;
    tbody.querySelector("[id$=_delivery_arrival_at]").style.opacity = "1";
    tbody.querySelector("[id$=_delivery_arrival_time]").style.opacity = "1";
  }

  //////////////////
  // Copy Section //
  //////////////////

  copyIndeliveryAtToStartDate(event) {
    const tbody = event.target.closest("tbody");
    const type = tbody.getAttribute("name");
    if (type !== "InDelivery") return;

    const deliveryAt = tbody.querySelector("[id$=_delivery_at]").value;
    if (!deliveryAt) return;

    this.element.querySelector("#order_start_date").value = deliveryAt;
  }

  copyOutdeliveryArrivalAtToDeadlineAt(event) {
    const tbody = event.target.closest("tbody");
    const type = tbody.getAttribute("name");
    if (type !== "OutDelivery") return;

    const deliveryArrivalAt = tbody.querySelector(
      "[id$=_delivery_arrival_at]"
    ).value;
    if (!deliveryArrivalAt) return;

    this.element.querySelector("#order_deadline_at").value = deliveryArrivalAt;
  }

  copyOutdeliveryArrivalTimeToDeadlineTime(event) {
    const tbody = event.target.closest("tbody");
    const type = tbody.getAttribute("name");
    if (type !== "OutDelivery") return;

    const deliveryArrivalTime = tbody.querySelector(
      "[id$=_delivery_arrival_time]"
    ).value;
    if (!deliveryArrivalTime) return;

    this.element.querySelector("#order_deadline_time").value =
      deliveryArrivalTime;
  }

  copyInspectionDisplayName(event) {
    const value = event.target.value;
    let inspection_display_name = "";
    if (value === "得意先") {
      const select = this.element.querySelector("[id$=_branch_id]");
      const selectedText = select.selectedOptions[0]?.text;
      inspection_display_name = selectedText.split(" ")[1];
    }
    this.element.querySelector("[id$=_inspection_display_name]").value =
      inspection_display_name;
  }
}
